import Row from '@components/Row';
import DecreaseIcon from '@components/Stepper/DecreaseIcon';
import IncreaseIcon from '@components/Stepper/IncreaseIcon';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { pressActionEffect } from '@styles/mixin';
import { MouseEvent } from 'react';

export type StepperSize = 'sm' | 'lg';

interface Props {
    value: number;
    increase: () => void;
    decrease: () => void;
    min?: number;
    max?: number;
    size?: StepperSize;
    disabled?: boolean;
}

function Stepper(props: Props) {
    const {
        value, min, max, size = 'lg', increase, decrease, disabled,
    } = props;
    const handleIncrease = (e: MouseEvent<HTMLOrSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (max !== undefined && value >= max) {
            return;
        }
        increase();
    };
    const handleDecrease = (e: MouseEvent<HTMLOrSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (min !== undefined && value <= min) {
            return;
        }
        decrease();
    };
    const decreaseDisabled = disabled || (min !== undefined && value <= min);
    const increaseDisabled = disabled || (max !== undefined && value >= max);
    const iconSize = size === 'sm' ? 20 : 24;

    return <Container align='center'
        justify='space-between'
        size={size} >
        <DecreaseIcon
            onClick={handleDecrease}
            size={iconSize}
            cursor='pointer'
            color={decreaseDisabled ? colors.gray5 : colors.gray7}
            css={pressActionEffect}/>
        <Text size={size === 'sm' ? 'body-long' : 'title'}
            css={valueCss}
            color={colors.textSecondary} >
            {value}
        </Text>
        <IncreaseIcon onClick={handleIncrease}
            size={iconSize}
            cursor='pointer'
            color={increaseDisabled ? colors.gray5 : colors.gray7}
            css={pressActionEffect} />
    </Container>;
}

const Container = styled(Row)<{
    size: StepperSize;
}>`
    width: ${({ size }) => (size === 'lg' ? 110 : 84)}px;
`;

const valueCss = css`
    min-width: auto;
`;

export default Stepper;
